/**
 * Consume Server-Sent Events from a POST response body (fetch + ReadableStream).
 * Backend sends blocks: `event: <name>\ndata: <json>\n\n`
 */
export function parseSSEBlock(block) {
  let eventName = 'message';
  const dataLines = [];
  for (const line of block.split('\n')) {
    if (!line || line.startsWith(':')) continue;
    if (line.startsWith('event:')) {
      eventName = line.slice(6).trim();
    } else if (line.startsWith('data:')) {
      dataLines.push(line.slice(5).trimStart());
    }
  }
  if (dataLines.length === 0) return null;
  const payload = dataLines.join('\n');
  try {
    return { event: eventName, data: JSON.parse(payload) };
  } catch {
    return { event: eventName, data: { raw: payload } };
  }
}

export async function readSSEStream(responseBody, onEvent) {
  const reader = responseBody.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });

    let sep;
    while ((sep = buffer.indexOf('\n\n')) !== -1) {
      const raw = buffer.slice(0, sep).trim();
      buffer = buffer.slice(sep + 2);
      if (!raw) continue;
      const parsed = parseSSEBlock(raw);
      if (parsed) onEvent(parsed.event, parsed.data);
    }
  }
}

/**
 * POST to chat v2 streaming endpoints and invoke onEvent for each SSE frame.
 */
export async function streamChatV2Post(url, body, token, onEvent, signal) {
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
    signal,
  });

  if (!res.ok) {
    let detail = res.statusText;
    try {
      const t = await res.text();
      if (t) detail = t;
    } catch { /* ignore */ }
    throw new Error(detail);
  }

  if (!res.body) {
    throw new Error('Empty response body');
  }

  await readSSEStream(res.body, onEvent);
}
